// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a28b2b32","840":"8685f7f5"}[chunkId] + ".chunk.js";
};